<template>
  <p class="p-cjt">
    <span v-if="!iflogin">
      <a class="ksy-ml-4" @click="handleClickLink()">登录</a>
      <button @click="handleClickLink('login?loginType=3')" type="primary" class="ksy-ml-4">注册</button>
    </span>
    <span v-if="iflogin">
      <a href="/client/shoppingCart" class="shopping-cart-box">
        <img src="https://static.xyb2b.com/images/2b5a253a919036981a8d95632a3b60df.svg" width="20px" />
        <span class="num">{{ carNum }}</span>
      </a>
      <a href="/client/stationLetter" class="shopping-cart-box">
        <img src="https://static.xyb2b.com/images/e6e98c2ab7ff0d5ced033fa5533ad6e3.svg" width="16px" />
        <span class="num">{{ unread }}</span>
      </a>
      <a-popover v-model="userMenu" :title="null" trigger="hover" placement="bottom" overlayClassName="usermenubox">
        <div class="usermenu" slot="content">
          <div>
            <div class="item">
              <svg t="1720693198006" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="6971" xmlns:xlink="http://www.w3.org/1999/xlink" width="16"
                height="16">
                <path
                  d="M620.79 195.43H389.25c-0.6 0-1.1-0.49-1.1-1.1V96.35c0-0.6 0.49-1.1 1.1-1.1H620.8c0.6 0 1.1 0.49 1.1 1.1v97.98c-0.01 0.61-0.5 1.1-1.11 1.1z"
                  p-id="6972" fill="#c2c5c6"></path>
                <path
                  d="M743.12 159.74h-90.99c-1.35 32.91-28.49 59.47-61.73 59.47H419.63c-33.22 0-60.38-26.56-61.73-59.47h-90.98c-50.31 0-91.46 41.15-91.46 91.46v518.3c0 50.3 41.15 91.46 91.46 91.46h476.19c50.31 0 91.46-41.16 91.46-91.46V251.2c0.01-50.31-41.14-91.46-91.45-91.46z m-66.55 512.24h-343.1c-12.64 0-22.86-10.23-22.86-22.86 0-12.64 10.23-22.86 22.86-22.86h343.1c12.64 0 22.86 10.23 22.86 22.86 0.01 12.63-10.22 22.86-22.86 22.86z m0-139.37h-343.1c-12.64 0-22.86-10.23-22.86-22.86 0-12.64 10.23-22.86 22.86-22.86h343.1c12.64 0 22.86 10.23 22.86 22.86 0.01 12.63-10.22 22.86-22.86 22.86z m0-139.38h-343.1c-12.64 0-22.86-10.23-22.86-22.86 0-12.64 10.23-22.86 22.86-22.86h343.1c12.64 0 22.86 10.23 22.86 22.86 0.01 12.64-10.22 22.86-22.86 22.86z"
                  p-id="6973" fill="#c2c5c6"></path>
              </svg>
              <a @click="checkPage('orderList')">我的订单</a>
            </div>
            <div class="item" v-if="PROCESS_ENV.NODE_PLA === 'kby'">
              <svg t="1720693042906" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="5144" width="16" height="16"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <path
                  d="M46.805333 516.352a469.333333 469.333333 0 1 1 469.333334 469.333333 468.053333 468.053333 0 0 1-469.333334-469.333333z m490.666667 29.866667l115.2 230.4h81.066667l-128-238.933334 25.6-12.8a138.325333 138.325333 0 0 0 55.466666-55.466666 162.133333 162.133333 0 0 0 21.333334-81.066667 176.170667 176.170667 0 0 0-21.333334-81.066667 136.533333 136.533333 0 0 0-55.466666-55.466666 162.602667 162.602667 0 0 0-81.066667-21.333334h-213.333333v546.133334h64v-230.4z m-140.8-64v-192h153.6a85.76 85.76 0 0 1 46.933333 12.8 79.616 79.616 0 0 1 29.866667 34.133333 116.266667 116.266667 0 0 1 12.8 51.2 92.586667 92.586667 0 0 1-12.8 51.2 67.328 67.328 0 0 1-29.866667 29.866667 85.76 85.76 0 0 1-46.933333 12.8z"
                  p-id="5145" fill="#c2c5c6"></path>
              </svg>
              <a @click="checkPage('myBrand')">我的商标</a>
            </div>
            <!-- <div class="item">
              <img src="@/assets/images/common/user-p.svg" class="ksy-pb-1" /><a @click="checkPage('myPatent')"
                >我的专利</a
              >
            </div>
            <div class="item">
              <img src="@/assets/images/common/user-coupon.svg" class="ksy-pb-1" /><a @click="checkPage('coupon')"
                >我的优惠券</a
              >
            </div> -->
            <div class="item">
              <svg t="1720693250176" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="8991" xmlns:xlink="http://www.w3.org/1999/xlink" width="16"
                height="16">
                <path
                  d="M511.999488 66.861804c-245.825778 0-445.138196 199.284789-445.138196 445.138196 0 245.852384 199.312418 445.137173 445.138196 445.137173 245.880013 0 445.138196-199.284789 445.138196-445.137173C957.137685 266.146593 757.879502 66.861804 511.999488 66.861804zM750.761384 762.417353c-15.377222 0-27.821649-12.443403-27.821649-27.821649 0-116.2834-94.602611-210.886011-210.94127-210.886011-116.2834 0-210.886011 94.603635-210.886011 210.886011 0 15.377222-12.443403 27.821649-27.821649 27.821649s-27.821649-12.443403-27.821649-27.821649c0-117.070322 76.399017-215.667921 181.543729-251.368004-49.502437-29.28907-83.137489-82.675978-83.137489-144.267754 0-92.727914 75.420737-168.17628 168.122045-168.17628s168.123069 75.448366 168.123069 168.17628c0 61.591777-33.580816 114.979708-83.137489 144.267754 105.198947 35.700083 181.597965 134.297682 181.597965 251.368004C778.583033 749.97395 766.138606 762.417353 750.761384 762.417353z"
                  fill="#c2c5c6" p-id="8992"></path>
                <path
                  d="M511.999488 226.425939c-62.000076 0-112.479771 50.480718-112.479771 112.534006 0 62.026682 50.479695 112.5074 112.479771 112.5074 62.055334 0 112.480794-50.480718 112.480794-112.5074C624.480282 276.905634 574.0538 226.425939 511.999488 226.425939z"
                  fill="#c2c5c6" p-id="8993"></path>
              </svg>
              <a @click="checkPage('user')">个人信息</a>
            </div>
          </div>

          <div class="out hand" @click="loginOut">
            <img src="@/assets/images/common/user-out.svg" class="ksy-pb-1 ksy-mt-1" />
            安全退出
          </div>
        </div>
        <img src="@/assets/images/common/user.png" class="ksy-mr-2" style="width: 34px" />
        <span class="hand nickstyle nick" v-if="nickName !== ''">{{ nickName | stringSlice(5) }}</span>
        <span class="hand nickstyle acc" v-else-if="account !== ''">{{ account | hideNumber }}</span>

        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="5" viewBox="0 0 9 5" fill="none"
          :style="{ width: '10px', height: '10px', marginLeft: '10px', transform: `rotate(${userMenu ? '0' : '180deg'})` }">
          <path
            d="M4.15474 4.9699C4.08122 4.97162 4.00871 4.9525 3.94559 4.91477C3.88247 4.87703 3.83132 4.8222 3.79804 4.75663L0.0901334 0.639018C0.0257221 0.561594 -0.00621923 0.462245 0.00100462 0.361792C0.00822848 0.26134 0.0540567 0.167583 0.128883 0.100175C0.20371 0.0327666 0.301725 -0.00305989 0.402384 0.00020507C0.503043 0.00347003 0.598531 0.0455729 0.668832 0.117689L4.15474 3.9896L7.63999 0.117689C7.71034 0.0455729 7.80581 0.00347003 7.90646 0.00020507C8.00711 -0.00305989 8.10513 0.0327666 8.17997 0.100175C8.2548 0.167583 8.30063 0.26134 8.30787 0.361792C8.31504 0.462245 8.28311 0.561594 8.21869 0.639018L4.51081 4.75476C4.47831 4.81877 4.42871 4.87254 4.3675 4.91007C4.3063 4.94761 4.23589 4.96745 4.16409 4.9674L4.15474 4.9699Z"
            fill="#4E5969" />
        </svg>
      </a-popover>
    </span>
  </p>
</template>

<script>
import { logout } from '@/api/login/login.js';
import { getInfo1 } from '@/api/user/userModule';
import Cookies from 'js-cookie';
import { totalShoppingCart } from '@/api/shoppingCar/shoppingCar';
import { mapMutations } from 'vuex';
import { getUnreadMessageCount } from '../../api/stationLetter.js';
import { clearCJTSupportWidgetCustomerVerification, confirmCJTSupportWidgetCustomer } from '@/utils/cjtSupportWidget';

export default {
  computed: {
    carNum() {
      return this.$store.state.breadcrumb.carNum;
    },
    isWork() {
      return this.$store.state.login.leftShow;
    },
    iflogin() {
      return this.$store.state.login.isLogin;
    },
  },
  filters: {
    hideNumber(str) {
      if (str) {
        return str.replace(str.substring(3, 7), '****');
      } else {
        return '';
      }
    },
    stringSlice(value, length) {
      value === undefined || value === null ? (value = '') : '';
      value.length > length ? (value = value.slice(0, length - 1) + '...') : value;
      return value;
    },
  },
  data() {
    return {
      nickName: '', // 昵称
      account: '',
      userMenu: false,
      unread: 0,
    };
  },
  mounted() {
    // let tokenl = localStorage.getItem('token');
    // let sid = localStorage.getItem('sessionId');
    if (this.iflogin) {
      this.getUinfo();
      this.getShoppingCar();
    }
  },
  watch: {
    "$route": {
      handler() {
        if (this.iflogin) {
          getUnreadMessageCount({}).then(res => this.unread = res.data);
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations(['setUserInfo']),
    handleClickLink(link = 'login') {
      const host = `/client/${link}`;
      // window.open(host);
      location.href = host;
    },
    // 获取购物车数量
    getShoppingCar() {
      totalShoppingCart().then((res) => {
        this.$store.commit('saveCarNumStatue', res.data);
      });
    },
    // 用户中心获取用户信息
    getUinfo() {
      let self = this;
      getInfo1()
        .then(
          (res) => {
            if (res.code === 0) {
              const userInfo = res.data;
              userInfo.enterpriseId = 3;
              this.setUserInfo(userInfo);
              localStorage.setItem('userInfo', JSON.stringify(userInfo));
              if (!sessionStorage.getItem('suspendAdvertisement')) {
                res.data.payFlag === 1
                  ? sessionStorage.setItem('suspendAdvertisement', false)
                  : sessionStorage.setItem('suspendAdvertisement', true);
                try {
                  this.$parent.$children[1].showSuspendAdvertisement();
                } catch (error) {
                  console.log(error);
                }
              }
              // this.infos = res.data;
              localStorage.setItem('objInfo', JSON.stringify(res.data)); // save local
              confirmCJTSupportWidgetCustomer();
              // 神策关联用户
              this.$sensors.login(res.data.userMobile, () => {
                this.$sensors.quick('autoTrack');
              });

              self.nickName = res.data.nickname;
              self.account = res.data.account;
              // 判断会员卡是否有效
              if (res.data.userDetail.vipEndTime) {
                const endTime = new Date(res.data.userDetail.vipEndTime).getTime();
                const nowTime = new Date().getTime();
                if (endTime > nowTime) {
                  getMembershipCardById(res.data.userDetail.membershipCardId).then((res) => {
                    if (res.code === 0) {
                      const detail = res.data;
                      if (detail) {
                        localStorage.setItem('vipInfo', JSON.stringify(detail));
                        localStorage.setItem('vipName', detail.membershipCardName);
                      }
                    }
                  });
                } else {
                  localStorage.setItem('vipName', '未开通会员');
                  localStorage.setItem('vipInfo', null);
                }
              } else {
                localStorage.setItem('vipName', '未开通会员');
                localStorage.setItem('vipInfo', null);
              }
            } else {
              clearCJTSupportWidgetCustomerVerification();
              this.$Message.error(res.message);
            }
          },
          (err) => {
            clearCJTSupportWidgetCustomerVerification();
            this.$Message.error(err.message);
          }
        )
        .finally(() => { });
    },
    goShopingCar() {
      this.$router.push({ path: '/shoppingCart' });
    },
    // 退出
    loginOut() {
      logout();
      localStorage.removeItem('token');
      localStorage.removeItem('sessionId');

      Cookies.remove('token');
      Cookies.remove('sessionId');
      this.$store.commit('saveLogin', false);
      this.$store.commit('saveLeft', false);

      // window.location.href = this.homePageUrl;
    },

    checkPage(page) {
      this.$store.commit('saveMenuName', '/' + page);

      this.$router.push({ path: '/' + page });
    },
  },
};
</script>

<style lang="less" scoped>
p {
  margin-bottom: 0;
}

a {
  color: rgba(0, 0, 0, 0.9);
}

button {
  width: 60px;
  height: 32px;
  line-height: 32px;
  border: 0;
  background: #3a7fff;
  border-radius: 2px 2px 2px 2px;
  text-align: center;
  font-size: 16px;
  color: #fff;
  cursor: pointer;

  &:hover {
    background: #549bff;
  }
}

.p-cjt {
  a {
    color: #333333;

    &:hover {
      color: #333333 !important;
    }
  }

  button {
    background: #3370ff;
    color: rgba(255, 255, 255, 0.9);
    margin-left: 20px;
  }
}

.usercar {
  width: 94px;
  height: 32px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 2px 2px 2px 2px;
  opacity: 1;
  padding: 0px 10px;
  margin-right: 35px;
  position: relative;

  img {
    margin-right: 5px;
    margin-top: -3px;
  }

  .red {
    line-height: 18px;
    display: inline-block;
    width: 18px;
    height: 18px;
    background-color: #ff6600;
    border-radius: 50%;
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    position: absolute;
    top: -6px;
    right: -6px;
  }
}
</style>
<style lang="less">
.usermenubox {
  border-radius: 2px;

  .ant-popover-inner-content {
    padding: 0px;
  }

  .ant-popover-arrow {
    display: none;
  }

  .ant-popover-inner {
    border-radius: 4px;
  }
}

.usermenu {
  width: 150px;
  // height: 245px;
  background: #ffffff;
  box-shadow: 0px 2px 12px 0px rgba(16, 68, 166, 0.07);
  opacity: 1;
  color: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  // padding: 16px 20px;
  padding-top: 5px;

  .item {
    height: 32px;
    line-height: 32px;
    margin-top: 6px;
    margin-bottom: 6px;
    padding-left: 20px;

    img {
      margin-right: 4px;
      margin-top: 4px;
    }

    svg {
      margin-right: 4px;
      position: relative;
      top: 3px;
    }
  }

  .out {
    height: 44px;
    line-height: 44px;
    background: #ffffff;
    box-shadow: 0px -1px 4px 0px rgba(16, 68, 166, 0.07);
    opacity: 1;
    padding-left: 20px;
    border-radius: 0px 0px 4px 4px;
  }

  a {
    color: rgba(0, 0, 0, 0.6);
  }

  a:hover {
    color: #1890ff;
  }
}

.nickstyle {
  font-size: 16px;
}

.shopping-cart-box {
  margin-right: 25px;
  display: inline-block;
  width: 32px;
  height: 32px;
  line-height: 32px;
  cursor: pointer;
  background-color: #F0F2FF;
  border-radius: 50%;
  text-align: center;
  position: relative;

  .num {
    position: absolute;
    top: -6px;
    right: -6px;
    height: 18px;
    min-width: 18px;
    padding: 0 4px;
    line-height: 18px;
    background-color: #FF6600;
    border-radius: 88888px;
    color: #FFFFFF;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/UserInfo.vue